import React, { Component } from "react";
import { Typography, TypographyVariants } from "@trussle/external-components";
import { IAccordionItem } from "../../../types/IAccordionItem";
import { IContentfulBackgroundColour } from "../../../types/IContentfulBackgroundColour";
import { Heading } from "../../Heading";

import { RichText } from "../../RichText";
import "./styles.scss";
import { GatsbyImageOrSvg } from "../../../utils/GatsbyImageOrSvg/GatsbyImageOrSvg";

export interface IProps {
  backgroundColour: IContentfulBackgroundColour;
  item: IAccordionItem;
  index: number;
}

interface IState {
  opened: boolean;
}

class AccordionItem extends Component<IProps, IState> {
  // eslint-disable-next-line react/state-in-constructor
  public state = {
    opened: false,
  };

  public toggleOpenedState = () => {
    const { opened } = this.state;
    this.setState({ opened: !opened });
  };

  public render() {
    const { opened } = this.state;
    const {
      backgroundColour,
      item: {
        title,
        content,
        secondaryTitle,
        image,
        headingType,
        secondaryHeadingType,
      },
      index,
    } = this.props;
    const openedClass = opened
      ? "accordion-item--opened"
      : "accordion-item--closed";
    const hasSecondaryTitleOrImage = secondaryTitle || image;

    return (
      <div
        className={`accordion-item ${openedClass} accordion-item--background-${backgroundColour}`}
        role="region"
        aria-label={`Accordion item ${index}`}
      >
        <button
          type="button"
          className="accordion-item__head"
          onClick={this.toggleOpenedState}
        >
          <Typography
            classes="accordion-item__title"
            variant={(headingType as TypographyVariants) || "h2"}
            id={`accordion-item-title-${index}`}
          >
            {title}
          </Typography>
          <span className="accordion-item__icon" />
        </button>
        <div className="accordion-item__body">
          {hasSecondaryTitleOrImage && (
            <div className="accordion-item__secondaryHeader">
              {secondaryTitle && (
                <div className="accordion-item__secondaryTitle">
                  <Heading
                    className="accordion-item__title"
                    type={secondaryHeadingType || "h3"}
                    id={`secondary-accordion-item-title-${index}`}
                  >
                    {secondaryTitle}
                  </Heading>
                </div>
              )}
              {image && (
                <GatsbyImageOrSvg image={image} loading="lazy" alt={image.title} />
              )}
            </div>
          )}
          <Typography
            variant="body1"
            classes="styledRichTextContainer"
            id={`accordion-item-content-${index}`}
          >
            <RichText
              contrastText={false}
              className={`accordion-item__content accordion-item__content-${index}`}
              content={content}
            />
          </Typography>
        </div>
      </div>
    );
  }
}

export { AccordionItem };
